import React, { Component } from 'react'

// Components
import Menu from 'components/dashboard/shared/menu'

const Sidebar = ({ locale, region, resources }) => (
  <aside className='sidebar'>
    <nav>
      <Menu
        className='sidebar__pages-links'
        locale={locale}
        region={region}
        resources={resources}
      />
    </nav>
  </aside>
)

export default Sidebar



// WEBPACK FOOTER //
// ./app/javascript/components/application/layout/sidebar.js